/**
 *
 * ScrollToTop
 *
 */

import { useEffect, useLayoutEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';

function ScrollToTop({ history }) {
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);

  // useEffect(() => {
  //   const unlisten = history.listen(() => {
  //     document.getElementById('layout-content').scrollIntoView();
  //   });
  //   return () => {
  //     unlisten();
  //   };
  // });

  return null;
}

export default withRouter(ScrollToTop);